module.exports = __webpack_public_path__ + "img/4f4b4a9.jpg";